<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header" v-if="auth.profile">
      <i class="fa fa-user md-5" :class="{ 'text-secondary' : pause }" title="toggle auto logout"></i>
      <b-badge v-if="s" pill :variant="pause ? 'secondary' : 'success'">{{s}}</b-badge>
      {{ auth.profile.username }}
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center"><strong>{{ auth && auth.profile && auth.profile.permissions ? auth.profile.permissions : '-' }}</strong></b-dropdown-header>
      <!-- <b-dropdown-item :disabled="true">
        <i class="fa fa-shopping-cart" /> {
      </b-dropdown-item> -->
      <!-- <b-dropdown-item @click="logout"><i class="fa fa-lock" /> Logout</b-dropdown-item> -->
      <b-dropdown-item to="/management/profile"><i class="fa fa-wrench" /> Profile</b-dropdown-item>
      <b-dropdown-divider/>
      <b-dropdown-item to="/management/signup"><i class="fa fa-sitemap" /> Management</b-dropdown-item>
      <b-dropdown-divider v-if="auth.profile.permissions.toLowerCase() != 'sales'"/>
      <b-dropdown-item v-if="auth.profile.permissions.toLowerCase() != 'sales'" to="/wmds/dashboard"><i class="fa fa-sitemap" /> WMDS</b-dropdown-item>
      <b-dropdown-item v-if="auth.profile.permissions.toLowerCase() != 'sales'" to="/wsfinder/dashboard"><i class="fa fa-search-plus" /> WSFinder</b-dropdown-item>
      <b-dropdown-item v-if="auth.profile.permissions.toLowerCase() != 'sales'" to="/webcastle/dashboard"><i class="fa fa-fort-awesome"></i> WebCastle</b-dropdown-item>
      <b-dropdown-item v-if="auth.profile.permissions.toLowerCase() != 'sales'" to="/integrity"><i class="fa fa-shield" /> Integrity</b-dropdown-item>
      <b-dropdown-item v-if="auth.profile.permissions.toLowerCase() != 'sales'" to="/board"><i class="fa fa-bars"/> Board</b-dropdown-item>
      <!-- <b-dropdown-divider/> -->
      <!-- <b-dropdown-item to="/pay"><i class="fa fa-usd"/> Pay</b-dropdown-item> -->

        <!-- <b-badge variant="info">{{ itemsCount }}</b-badge> -->

      <!-- <b-dropdown-item><i class="fa fa-user" to="/profile" /> Profile</b-dropdown-item>
      <b-dropdown-item><i class="fa fa-wrench" /> Settings</b-dropdown-item>
      <b-dropdown-item><i class="fa fa-usd" /> Payments
        <b-badge variant="secondary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-item><i class="fa fa-file" /> Projects
        <b-badge variant="primary">{{ itemsCount }}</b-badge>
      </b-dropdown-item>
      <b-dropdown-divider/> -->
      <!-- <b-dropdown-item><i class="fa fa-shield" /> Lock Account</b-dropdown-item> -->
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue';
import auth from '@/service/auth';

export default {
  props: ['pause', 'stale'],
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => ({ itemsCount: 42, auth, s: '', }),
  methods: {
    logout() {
      auth.logout(); this.$router.push('/auth');
    },
  },
  destroyed: function() { console.log('[vue] private dropdown', 'destroyed'); },
  mounted: function() { console.log('[vue] private dropdown', 'mounted'); this.s = this.stale },
}
</script>
